import { VerifyCodeStepFormFieldsEnum, yupLanding } from "@ryde/utils-landings";

export const yupVerifyCodeLandingTnufaValidationSchema = {
  [VerifyCodeStepFormFieldsEnum.VerificationCode]: yupLanding
    .string()
    .required(),
};
